import validate from "/home/runner/work/hokify/hokify/node_modules/.pnpm/nuxt@3.17.6_@types+node@20.19.0_eslint@8.57.1_sass@1.44.0_tsx@4.20.3_typescript@5.9.3/node_modules/nuxt/dist/pages/runtime/validate.js";
import alias_45redirect_45global from "/home/runner/work/hokify/hokify/apps/international-page-app/src/middleware/alias-redirect.global.ts";
import manifest_45route_45rule from "/home/runner/work/hokify/hokify/node_modules/.pnpm/nuxt@3.17.6_@types+node@20.19.0_eslint@8.57.1_sass@1.44.0_tsx@4.20.3_typescript@5.9.3/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  alias_45redirect_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}